export default __webpack_public_path__ + "static/media/truesume_v.df20060a.png";